import Component from '../base/component';

class Modal extends Component {

    constructor(el, opts) {
        super(el, opts);


        this._restrictedEvents = [
            'focus',
            // 'click',
            'DOMMouseScroll',
            'mousewheel',
            'touchmove',
            'scroll'
        ];

        this.restrictFocus = function restrictFocus(e)  {

            if (this.getState('isModalOpen') && !this.el.contains( e.target ) ) {
                e.stopPropagation();
                this.el.focus();
            }

        }.bind(this);

        this.$el.setAttribute('role', 'dialog');
        this.$el.setAttribute('tabindex', '-1');
        this.$el.setAttribute('aria-hidden', 'false');

        this.on('change:isModalOpen', (isOpen) => {
            if (isOpen) {
                this.show();
            } else {
                this.hide();
            }
        });

    }

    show() {

        this.$el.setAttribute('tabindex', '0');
        this.$el.setAttribute('aria-hidden', 'false');
        this.$el.focus();

        this._restrictedEvents.forEach((event) => {
            document.addEventListener(event, this.restrictFocus, true);
        });
    }

    hide() {

        this.$el.setAttribute('tabindex', '-1');
        this.$el.setAttribute('aria-hidden', 'true');

        this._restrictedEvents.forEach((event) => {
            document.removeEventListener(event, this.restrictFocus, true);
        });
    }

    getInitialState() {
        return {
            isModalOpen: false
        };
    }
}

export default Modal;


/** WEBPACK FOOTER **
 ** ./components/modal.js
 **/